"use client";

import type React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
  VStack,
} from "@chakra-ui/react";
import { OptOutSensitiveData } from "./security/OptOutSensitiveData";
import { FallbackVoiceSelect } from "./security/FallbackVoiceSelect";

interface SecuritySettingsProps {
  agentId: string;
  initialOptOut: boolean;
  initialFallbackVoiceIds: string[] | null;
}

export const SecuritySettings: React.FC<SecuritySettingsProps> = ({
  agentId,
  initialOptOut,
  initialFallbackVoiceIds,
}) => {
  return (
    <Accordion allowToggle>
      <AccordionItem border="none">
        <h2>
          <AccordionButton
            py={3}
            px={4}
            bg="transparent"
            _hover={{ bg: "primary.50" }}
            _active={{ bg: "primary.100" }}
            _focusVisible={{
              boxShadow: "0 0 0 1px var(--chakra-colors-primary-500)",
            }}
            borderRadius="md"
          >
            <Box
              flex="1"
              textAlign="left"
              fontSize="sm"
              display="flex"
              alignItems="center"
              gap={2}
              color="primary.600"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M10 1.75L16.1627 3.1195C16.3293 3.15652 16.4782 3.24922 16.585 3.3823C16.6918 3.51538 16.75 3.68089 16.75 3.8515V11.3417C16.7499 12.0826 16.567 12.8119 16.2174 13.465C15.8678 14.1181 15.3624 14.6749 14.746 15.0858L10 18.25L5.254 15.0858C4.63771 14.6749 4.13235 14.1183 3.78276 13.4653C3.43318 12.8124 3.25018 12.0832 3.25 11.3425V3.8515C3.25003 3.68089 3.30823 3.51538 3.41499 3.3823C3.52176 3.24922 3.6707 3.15652 3.83725 3.1195L10 1.75ZM10 3.28675L4.75 4.453V11.3417C4.75001 11.8356 4.87193 12.3218 5.10495 12.7572C5.33796 13.1926 5.67486 13.5638 6.08575 13.8378L10 16.4478L13.9142 13.8378C14.325 13.5639 14.6619 13.1928 14.8949 12.7575C15.1279 12.3223 15.2499 11.8362 15.25 11.3425V4.453L10 3.2875V3.28675ZM10 6.25C10.3303 6.24985 10.6513 6.35869 10.9134 6.55965C11.1755 6.7606 11.3639 7.04243 11.4495 7.3614C11.535 7.68038 11.5129 8.01868 11.3866 8.32381C11.2603 8.62895 11.0367 8.88386 10.7508 9.049L10.75 12.25H9.25V9.049C8.96406 8.88389 8.74058 8.62905 8.61423 8.32399C8.48788 8.01893 8.46572 7.6807 8.55118 7.36177C8.63664 7.04283 8.82495 6.761 9.0869 6.55999C9.34885 6.35898 9.66981 6.25001 10 6.25Z"
                  fill="currentColor"
                />
              </svg>
              Security Settings
            </Box>
            <AccordionIcon color="primary.600" />
          </AccordionButton>
        </h2>

        <AccordionPanel
          pb={4}
          bg="primary.50"
          borderWidth="1px"
          borderColor="gray.200"
          borderRadius="md"
          position="relative"
          overflow="visible"
        >
          <VStack spacing={6} align="stretch">
            <OptOutSensitiveData
              agentId={agentId}
              initialOptOut={initialOptOut}
            />
            <FallbackVoiceSelect
              agentId={agentId}
              initialFallbackVoiceIds={initialFallbackVoiceIds}
            />
          </VStack>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};
